export default "__VITE_ASSET__17bc6ce2__"